import { render, staticRenderFns } from "./PropertyTypeFiltersExtension.vue?vue&type=template&id=4d6fc713&scoped=true"
import script from "./PropertyTypeFiltersExtension.vue?vue&type=script&lang=js"
export * from "./PropertyTypeFiltersExtension.vue?vue&type=script&lang=js"
import style0 from "./PropertyTypeFiltersExtension.vue?vue&type=style&index=0&id=4d6fc713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fc713",
  null
  
)

export default component.exports